import styled from "styled-components";

export const AddressBtnStyled = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  height: 36px;

  padding: 6px 12px;
  border-radius: 14px;
  color: white;

  background-color: ${({ color }) => color};
`;
